import React from 'react';
import {
  ResponsiveContainer,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  Line,
  CartesianGrid,
} from 'recharts';
import { AxisDomain } from 'recharts/types/util/types';

export interface LineChartProps {
  data: any[];
  optimalMax?: number;
  optimalMin?: number;
}

export const RootineLineChart = (props: LineChartProps): JSX.Element => {
  const epochToString = (epoch: string): string => {
    const date = new Date(epoch);
    return `${date.toLocaleString('default', {
      month: 'short',
    })} ${date.getDate()}, ${date.getFullYear()}`;
  };

  const yDomain = (): AxisDomain | undefined => {
    if (!props.optimalMax || !props.optimalMin) {
      return undefined;
    }
    let results = props.data.map((d) => {
      return d.result;
    });
    results.sort();

    // pad 1/10th the size of our optimal range
    const pad = Math.round((props.optimalMax - props.optimalMin) / 10);

    // minimum of lowest result and optimalMin, with pad
    const min = Math.max(
      ...[Math.floor(Math.min(...[results[0], props.optimalMin])) - pad, 0]
    );

    // maximum of highest result and optimalMin, with pad
    const max =
      Math.max(...[results[results.length - 1], props.optimalMax]) + pad;

    return [min, max];
  };

  return (
    <>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={props.data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            domain={[
              props.data[0].date,
              props.data[props.data.length - 1].date,
            ]}
            padding={{ left: 30, right: 30 }}
            scale="time"
            type="number"
            tickFormatter={(epoch) => epochToString(epoch)}
            interval="preserveStartEnd"
          />
          <YAxis type="number" domain={yDomain()} />
          <Tooltip labelFormatter={(epoch) => epochToString(epoch)} />
          <Line
            type="monotone"
            dataKey="result"
            strokeWidth={5}
            stroke="#0075FF"
          />
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};
